import { Button, Icon } from '@mui/material';
import { GridToolbar, GridToolbarContainer } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from 'react';
import { NavLink as ReactRouterLink } from 'react-router-dom';

import { GeneralConstants } from 'app/constants';
import { PartnerMapUnion } from 'app/model';
import { partnerMapQueryService } from 'app/services';

import { PartnerMapGrid } from './partner-map-grid';

const CustomToolbar = (): React.ReactElement => (
    <GridToolbarContainer>
        <GridToolbar />
        <Button
            type='button'
            variant='text'
            color='success'
            sx={{ marginTop: '4px' }}
            component={ReactRouterLink}
            to='/cris/partner-maps/new'
            startIcon={<Icon color='success'>playlist_add</Icon>}
        >
            Add
        </Button>
    </GridToolbarContainer>
);

export const PartnerMapListing: React.FunctionComponent = () => {
    const [data, setData] = useState<PartnerMapUnion[]>([]);

    useEffect(() => {
        partnerMapQueryService.listAll({ pageSize: GeneralConstants.PAGE_SIZE_HUGE }).subscribe(setData);
    }, []);

    return <PartnerMapGrid rows={data} components={{ Toolbar: CustomToolbar }} />;
};
